import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState } from 'react';
import ModalWrapper from '../shared/ModalWrapper';
import PermissionWidget from './PermissionWidget';
import ShareTypeSelector from './ShareTypeSelector';
function AdminShareContentModal(_ref) {
  var data = _ref.data,
    onClose = _ref.onClose,
    _ref$initialShareType = _ref.initialShareType,
    initialShareType = _ref$initialShareType === void 0 ? null : _ref$initialShareType;
  var _useState = useState(initialShareType),
    _useState2 = _slicedToArray(_useState, 2),
    shareType = _useState2[0],
    setShareType = _useState2[1];
  var contentPermissions = data.contentPermissions,
    overallContentAudienceType = data.overallContentAudienceType;
  return /*#__PURE__*/React.createElement(ModalWrapper, {
    canShowAlert: true,
    showEditor: !!shareType,
    data: data,
    onClose: onClose,
    shareType: shareType,
    subtitle: /*#__PURE__*/React.createElement(PermissionWidget, {
      contentPermissions: contentPermissions
    })
  }, !shareType && /*#__PURE__*/React.createElement(ShareTypeSelector, {
    audience: overallContentAudienceType,
    onChange: setShareType
  }));
}
export default AdminShareContentModal;